import { Routes } from "../../services/route.service"
import { Redirect, useHistory } from "react-router"
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
export default function NotFound() {
    const history = useHistory();
   
    return (
        <section className="page_404">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-sm-10 col-sm-offset-1  text-center">
                            <div className="four_zero_four_bg" style={{
                                backgroundImage: `url("https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif")`,
                                backgroundPosition: "center",
                                height: "400px"
                            }}>
                                <h1 className="text-center">404</h1>
                            </div>
                            <div className="contant_box_404">
                                <h3 className="h2">
                                    Look like you're lost
                                </h3>
                                

                               
                                    <Button  variant="primary" style={{background: "#37334f",color: "white"}} className="custom-btn" color={"primary"}><a className="link_404">Go to Home</a></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}